export type MessageType = 'success' | 'error'

export type InfoMessage = {
  type: MessageType
  head: string
  body: string
}

export const GENERIC_ERROR: InfoMessage = {
  type: 'error',
  head: 'Fehler aufgetreten',
  body: `<p>In unserem System ist ein unerwarteter Fehler aufgetreten. Ihre Eingaben konnten nicht verarbeitet werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt nochmal.</p>
<p>Es wurde kein Vertrag abgeschlossen und keine Auswahl für Sie getroffen.</p>`
}

export function showMessage(msg = GENERIC_ERROR): void {
  const el = document.getElementById('msg')
  /* istanbul ignore next if */
  if (!el) {
    return
  }

  const icon = el.querySelector('.message__icon')
  /* istanbul ignore next else */
  if (icon) {
    icon.classList.toggle('message__icon--error', msg.type === 'error')
    icon.classList.toggle('message__icon--success', msg.type === 'success')
    icon.innerHTML = `<use xlink:href="#hint-${msg.type}_64"></use>`
  }

  const head = el.querySelector('.message__head')
  /* istanbul ignore next else */
  if (head) {
    (head as HTMLHeadElement).innerText = msg.head
  }

  const body = el.querySelector('.message__body')
  /* istanbul ignore next else */
  if (body) {
    (body as HTMLParagraphElement).innerHTML = msg.body
    el.classList.add('message--visible')
  }
}
